


import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Fingerprint from '@material-ui/icons/Fingerprint';
import SupervisorAccount from '@material-ui/icons/SupervisorAccount';
import Dashboard from '@material-ui/icons/Dashboard';
import AssignmentIcon from '@material-ui/icons/Assignment';
import Devices from '@material-ui/icons/Devices';
import DateRange from '@material-ui/icons/DateRange';
import Assessment from '@material-ui/icons/Assessment';
import AccountBox from '@material-ui/icons/AccountBox';
import LocationOn from '@material-ui/icons/LocationOn';
import DevicesOther from '@material-ui/icons/DevicesOther';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Star from '@material-ui/icons/Star';
import { NavLink } from 'react-router-dom';

const styles = theme => ({
  textColor: {
    color: theme.palette.primary.contrastText,
    fontSize: '1rem',
    minWidth: '30px'
  },
  activated: {
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
  },
  hover: {
    borderRadius: '1em',
    padding: '1px 7px',
    '&:hover': {
      fontSize: '14px',
      color: '#6880c3',
      padding: '1px 5px',
      backgroundColor: '#f2b002',
    }
  },
  iconPremium: {
    minWidth: '30px'
  },
  texte: {
    paddingLeft: '10px',
    paddingRight: '0px'
  },
  collapseIcon: {
    paddingLeft: '25px'
  },
  collapseName: {
    paddingLeft: '3px'
  }
});

class MenuItem extends React.Component {
  state = {
    premium: JSON.parse(localStorage.getItem('privileges')).isExportAfd,
    modalTerminoGratis: false,
    mouseHover: false,
    seconds: 15,
    menuItems: [
      {
        id: '1',
        open: false,
        name: 'Dashboard',
        icon: <Dashboard />,
        link: '/',
        collapse: null,
      },
      {
        id: '2',
        open: false,
        name: <Typography>Central de Atividades</Typography>,
        iconPremium: <Star style={{ color: '#f2b002' }} />,
        icon: <AssignmentIcon />,
        link: '/central-de-atividades',
        collapse: null,
        hoverPremium: false,
      },
      // {
      //   id: '3',
      //   open: false,
      //   name: <Typography >Central de Serviços</Typography>,
      //   icon: <Devices />,
      //   link: '/central-de-servicos',
      //   collapse: null,
      // },
      {
        id: '4',
        open: false,
        name: 'Escalas',
        icon: <DateRange />,
        link: '/escalas',
        collapse: null,
      },
      {
        id: '5',
        open: false,
        name: 'Locais',
        icon: <LocationOn />,
        link: '/locais',
      },
      // {
      //   id: '5',
      //   open: false,
      //   name: 'Dispositivos',
      //   icon: <DevicesOther />,
      //   link: '/devices',
      // },
      {
        id: '6',
        open: false,
        name: 'Funcionários',
        icon: <SupervisorAccount />,
        collapse: [
          {
            id: '6.1',
            name: 'Colaboradores',
            iconPremium: <Star style={{ color: '#f2b002' }} />,
            hoverPremium: false,
            link: '/colaboradores',
          },
          // {
          //   id: '6.1',
          //   name: 'Cadastrar funcionário',
          //   link: '/funcionarios/cadastrar',
          // },
          // {
          //   id: '6.2',
          //   name: 'Listar funcionários',
          //   link: '/funcionarios',
          // },
          // {
          //   id: '6.3',
          //   name: 'Importar funcionários',
          //   link: '/funcionarios/importar',
          // },
          {
            id: '6.2',
            name: 'Cargos',
            link: '/cargos',
          },
          {
            id: '6.5',
            name: 'Departamentos',
            link: '/departamentos',
          },
          // {
          //   id: '6.6',
          //   name: 'Desligados',
          //   link: '/demitidos',
          // },
          {
            id: '6.6',
            name: 'Configurações',
            link: '/aplicar-restricoes',
          },

        ],
      },
      {
        id: '7',
        open: false,
        name: 'Ponto',
        icon: <Fingerprint />,
        collapse: [
          {
            id: '7.1',
            name: 'Tratamento',
            iconPremium: <Star style={{ color: '#f2b002' }} />,
            hoverPremium: false,
            link: '/Tratamento',
          },
          // {
          //   id: '7.2',
          //   name: 'Acompanhamento',
          //   link: '/acompanhamento',
          // },
          {
            id: '7.3',
            name: 'Banco de Horas',
            iconPremium: <Star style={{ color: '#f2b002' }} />,
            hoverPremium: false,
            link: '/banco',
          },
          {
            id: '7.4',
            name: 'Feriados',
            iconPremium: <Star style={{ color: '#f2b002' }} />,
            hoverPremium: false,
            link: '/feriados',
          },
          {
            id: '7.5',
            name: 'Abonos',
            iconPremium: <Star style={{ color: '#f2b002' }} />,
            hoverPremium: false,
            link: '/abonos',
          }
        ],
      },
      {
        id: '8',
        open: false,
        name: 'Relatórios',
        icon: <Assessment />,
        iconPremium: <Star style={{ color: '#f2b002' }} />,
        hoverPremium: false,
        collapse: [
          {
            id: '8.1',
            name: 'Espelho de ponto',
            iconPremium: <Star style={{ color: '#f2b002' }} />,
            hoverPremium: false,
            link: '/relatorio',
          },
          {
            id: '8.2',
            name: 'Integração em AFD',
            iconPremium: <Star style={{ color: '#f2b002' }} />,
            hoverPremium: false,
            link: '/relatorio/afd',
          },
          {
            id: '8.4',
            name: 'Pontos com localização',
            iconPremium: <Star style={{ color: '#f2b002' }} />,
            hoverPremium: false,
            link: '/relatorio/local',
          },
          {
            id: '8.5',
            name: 'Faltas por período',
            iconPremium: <Star style={{ color: '#f2b002' }} />,
            hoverPremium: false,
            link: '/relatorio/faltas',
          },
          {
            id: '8.6',
            name: 'Lista de pontos',
            link: '/relatorio/list'
          }
        ],
      },
      {
        id: '9',
        open: false,
        name: 'Empresa',
        icon: <AccountBox />,
        collapse: [
          {
            id: '6.1',
            name: 'Atualizar Informações',
            link: '/atualizar-empresa',
          },
          {
            id: '6.2',
            name: 'Gestores',
            link: '/gestores',
          },
        ],
      },
      {
        id: '10',
        open: false,
        name: 'Assinaturas',
        icon: <Star />,
        link: '/assinatura',
      }
    ],
  };

  componentDidMount() {
    this.Cronometro();
  };

  componentDidUpdate() {
    if (!this.state.premium) {
      const newURL = window.location.pathname;
      this.state.menuItems.map((item) => {
        if (item.iconPremium) {
          if (newURL === item.link) {
            // Redirecione para a página inicial
            window.history.pushState(null, "", "/");
          }
        }
      });
    }
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.open === false) {
      const newMenuItems = this.state.menuItems;
      newMenuItems.map(item => (item.open = false));

      this.setState({ menuItems: newMenuItems });
    }
  };

  handleClick = (index) => {
    if (this.props.open === false) {
      this.props.handleOpen();
    }

    this.state.menuItems.map((item) => {
      if (item.id === index) {
        const newMenuItems = this.state.menuItems;

        newMenuItems.map(newItem =>
          (newItem.id === item.id ? (newItem.open = !newItem.open) : (newItem.open = false)));

        return this.setState({ menuItems: newMenuItems });
      }
      return null;
    });
  };

  Cronometro = () => {
    setInterval(() => {
      if (this.state.seconds > 0) {
        this.setState({ seconds: this.state.seconds - 1 })
      }
    }
      , 1000)
  };

  handleChangeHover = (id, status) => {
    if (!this.state.premium) {
      const updatedItems = this.state.menuItems.map(item => {
        if (item.id === id && item.hoverPremium != null) {
          return {
            ...item,
            hoverPremium: status,
          };
        }
        return item;
      });

      this.setState({
        menuItems: updatedItems,
      });
    }
  };

  handleChangeHoverCollapse = (itemId, collapseId, status) => {
    if (!this.state.premium) {
      const itemIndex = this.state.menuItems.findIndex(item => item.id === itemId);
      if (itemIndex !== -1) {
        const updatedCollapse = this.state.menuItems[itemIndex].collapse.map(item => {
          if (item.id === collapseId && item.hoverPremium != null) {
            return {
              ...item,
              hoverPremium: status,
            };
          }
          return item;
        });

        const updatedItems = [...this.state.menuItems];
        updatedItems[itemIndex] = {
          ...updatedItems[itemIndex],
          collapse: updatedCollapse,
        };

        this.setState({
          menuItems: updatedItems,
        });
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { premium } = this.state;

    return (
      <List className={classes.textColor}>
        {this.state.menuItems.map((item, index) => (
          <div key={item.id}>
            <ListItem
              className={classes.texte}
              button
              key={index}
              onClick={() => this.handleClick(item.id)}
              component={item.collapse ? null : NavLink}
              activeclassname={classes.activated}
              exact={item.collapse ? null : true}
              to={item.collapse ? null : premium ? item.link : item.hoverPremium ? '/assinatura' : item.link}
            >
              <ListItemIcon className={classes.textColor}>{item.icon}</ListItemIcon>
              <ListItemIcon className={classes.iconPremium}>{!premium ? item.iconPremium : ''}</ListItemIcon>
              <ListItemText
                onMouseEnter={() => this.handleChangeHover(item.id, true)}
                onMouseLeave={() => this.handleChangeHover(item.id, false)}
                disableTypography
                primary={premium ? item.name : item.hoverPremium ? 'Assine o Plano Premium' : item.name}
                className={premium ? '' : item.hoverPremium ? classes.hover : ''}
              />
              {item.collapse != null ? item.open === true ? <ExpandLess /> : <ExpandMore /> : null}
            </ListItem>
            {item.collapse
              ? item.collapse.map((collapseItem, index) => {
                if (collapseItem.privilege && (this.props.privileges && !this.props.privileges[collapseItem.privilege])) {
                  return null;
                }
                return (
                  <Collapse key={index} in={item.open} timeout="auto" appear unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItem
                        component={NavLink}
                        exact
                        to={premium ? collapseItem.link : collapseItem.hoverPremium ? '/assinatura' : collapseItem.link}
                        activeClassName={classes.activated}
                        button
                        disabled={collapseItem.disabled}
                      >
                        {collapseItem.iconPremium ? <ListItemIcon className={classes.collapseIcon}>{!premium ? collapseItem.iconPremium : ''}</ListItemIcon> : <></>}
                        <ListItemText
                          className={collapseItem.iconPremium ? [classes.collapseName, premium ? '' : classes.hover] : ''}
                          disableTypography
                          inset
                          primary={premium ? collapseItem.name : collapseItem.hoverPremium ? 'Assine o Plano Premium' : collapseItem.name}
                          onMouseEnter={() => this.handleChangeHoverCollapse(item.id, collapseItem.id, true)}
                          onMouseLeave={() => this.handleChangeHoverCollapse(item.id, collapseItem.id, false)}
                        />
                      </ListItem>
                    </List>
                  </Collapse>
                );
              })
              : null}
          </div>
        ))}
      </List>
    );
  }
}

MenuItem.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  privileges: state.auth.privileges,
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(MenuItem));






